/* eslint-disable */
import Api, {SERVER_URL} from '@/services/Api'


export default {
    digiRun(data){
        try {
            return Api().get('admin/digital-lit/');
        }catch(err){
            console.log(err);
            return err
        }
    },
    getGSheetRecords(data){
        try {
            return Api().get('classrooms/gsheet/');
        }catch(err){
            console.log(err);
            return err
        }
    },
    downloadReport(token, name, fileType, reportType){
        try {
            const url = SERVER_URL + 'admin/digital-lit/download/?token='+token+'&email='+name+'&fileType='+fileType
                +'&reportType='+reportType;
            const link = document.createElement('a');
            link.href = url;
            link.target = "_blank";
            document.body.appendChild(link);
            link.click();
        }catch(err){
            console.log(err);
            return err
        }
    },
    updateQuestionComponents(data){
        try {
            return Api().get('admin/digital-lit/update/');
        }catch(err){
            console.log(err);
            return err
        }
    },
    getPerformanceReport(data){
        try {
            return Api().get('admin/report/performance/');
        }catch(err){
            console.log(err);
            return err
        }
    },
    emailReport(email){
        try {
            return Api().get('admin/report/literacy/email?email='+email);
        }catch(err){
            console.log(err);
            return err
        }
    },
    massEmailReports(){
        try {
            return Api().get('admin/report/literacy/mass-email');
        }catch(err){
            console.log(err);
            return err
        }
    },

}
